// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37ce7","type":"styles_type__24BWe","choices":"styles_choices__3uBOo"};